<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap"> {{ getText(coachingConfig?.globalizationConfig, 'title') |
                uppercase }} </ion-label>
        </ion-item>

        <app-step-description *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration"
            [description]="getText( reviewConfig?.globalizationConfig, 'instructions' )"></app-step-description>

        <app-subordinate-profile [user]="userPreview" [getImageUrl]="getImageUrl.bind(this)">
        </app-subordinate-profile>

        <ion-card mode="ios" class="card-table-data" *ngIf="reviewConfig && coachingConfig && coachingForm">
            <form [formGroup]="coachingForm">
                <div
                    *ngFor="let group of coachingConfig.questionsGroups | questionGroupAttributes: user?.attributes; let groupIndex = index">
                    <h4 class="number">
                        {{ getSectionNumber('group-' + group.order) + ' - ' + getText(group.globalizationConfig, 'title') }}
                    </h4>
                    <ng-container *ngFor="let question of group.questions | questionAttribute: user.attributes : true">
                        <div class="questions">
                            <app-question-types
                                [question]="question"
                                [formGroup]="coachingForm"
                                [disableEdition]="true"></app-question-types>
                            <ion-col size="12" class="ion-align-self-center col-action" *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration">
                                <ng-container *ngIf="canValidate; else reviewQuestionStatus">
                                    <span class="label">{{ 'generic.actions' | translate }}</span>
                                    <div class="buttons-action">
                                        <ng-container *ngIf="isPersistedQuestionRefused(question); else groupedInteractiveButtons">
                                            <ion-button mode="ios" fill="outline" color="#000000"
                                                (click)="cancelQuestionRefuse(question)">
                                                <img class="goal-action-icon"
                                                    src="assets/imgs/goals/replay.svg"
                                                    alt="Replay" />
                                                {{ 'generic.goBack' | translate }}
                                            </ion-button>
                                            <ion-button mode="ios" class="refuse-button is-selected" fill="solid"
                                                [disabled]="true">
                                                <img class="goal-action-icon"
                                                    src="assets/imgs/goals/close.svg"
                                                    alt="Close" />
                                                {{ 'goalsInput.refuse' | translate }}
                                            </ion-button>
                                        </ng-container>
                                        <ng-template #groupedInteractiveButtons>
                                            <ng-container *ngIf="!isQuestionRefuseMode(question); else groupedRefuseModeButtons">
                                                <ion-button mode="ios" [fill]="question.approved === true ? 'solid' : 'outline'"
                                                    color="primary"
                                                    class="choice-button approve-choice"
                                                    [class.is-selected]="question.approved === true"
                                                    [disabled]="coachingRecordStatus === TwoPlusTwoCoachingStatus.Authorized"
                                                    (click)="setApprovedAndClearComment(question)">
                                                    <img class="goal-action-icon"
                                                        src="assets/imgs/goals/check.svg"
                                                        alt="Check"
                                                        [class.is-solid]="question.approved === true" />
                                                    {{ 'goalsInput.approve' | translate }}
                                                </ion-button>
                                                <ion-button mode="ios" class="refuse-button"
                                                    [class.is-selected]="question.approved === false"
                                                    [fill]="question.approved === false ? 'solid' : 'outline'"
                                                    [disabled]="coachingRecordStatus === TwoPlusTwoCoachingStatus.Authorized"
                                                    (click)="startQuestionRefuseMode(question)">
                                                    <img class="goal-action-icon"
                                                        src="assets/imgs/goals/close.svg"
                                                        alt="Close" />
                                                    {{ 'goalsInput.refuse' | translate }}
                                                </ion-button>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #groupedRefuseModeButtons>
                                            <ion-button mode="ios" fill="outline" color="#000000"
                                                (click)="cancelQuestionRefuse(question)">
                                                <img class="goal-action-icon"
                                                    src="assets/imgs/goals/replay.svg"
                                                    alt="Replay" />
                                                {{ 'generic.goBack' | translate }}
                                            </ion-button>
                                            <ion-button mode="ios" class="refuse-button is-selected" fill="solid"
                                                [disabled]="true">
                                                <img class="goal-action-icon"
                                                    src="assets/imgs/goals/close.svg"
                                                    alt="Close" />
                                                {{ 'goalsInput.refuse' | translate }}
                                            </ion-button>
                                        </ng-template>
                                    </div>
                                </ng-container>
                                <ng-template #reviewQuestionStatus>
                                    <span class="label">{{ 'generic.status' | translate }}</span>
                                    <span class="review-status" [class.is-rejected]="question.approved === false">
                                        {{ question.approved === false ? ('goalsInput.refuse' | translate) : ('generic.approved' | translate) }}
                                    </span>
                                </ng-template>
                            </ion-col>
                            <ion-col size="12" *ngIf="question.approved === false">
                                <ion-item lines="none" feedback [class.no-border]="!canValidate">
                                    <ion-label position="stacked"> Feedback </ion-label>
                                    <ion-textarea
                                        [placeholder]="'goalsValidation.rejectionInputPlaceholder' | translate"
                                        [formControlName]="'field' + (question.order) + 'Comment'"></ion-textarea>
                                </ion-item>
                            </ion-col>
                        </div>
                    </ng-container>
                </div>

                <div class="questions manager-comment-question-block">
                    <div class="text-type manager-comment-text-type">
                        <p class="title">{{ 'goalsValidation.managerComment' | translate}}</p>
                        <ion-textarea
                            autoGrow="true"
                            *ngIf="canValidate; else managerCommentReadOnly"
                            fullLined
                            [(ngModel)]="generalComments"
                            [ngModelOptions]="{ standalone: true }"
                        ></ion-textarea>
                        <ng-template #managerCommentReadOnly>
                            <p class="manager-comment-value">{{ generalComments }}</p>
                        </ng-template>
                    </div>
                </div>
            </form>

            <br /><br />
        </ion-card>

        <br />

        <ion-card mode="ios" class="card-table-data" *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration 
                && !hideGoalsOnGoalsReview 
                && !isUserAttributesInsideConsentGoals">
            <h4 class="number" *ngIf="(coachingConfig?.questions | questionAttribute: user?.attributes: true).length == 0
                && !showSkipTwoPlusTwoCoachingEvaluationFlag; else elseBlock">
                {{ getSectionNumber('goals') }} - {{ 'goalsValidation.validateGoals' | translate }}
            </h4>
            <ng-template #elseBlock>
                <h4 class="number" *ngIf="!showSkipTwoPlusTwoCoachingEvaluationFlag">
                    {{ getSectionNumber('goals') }} - {{ 'goalsValidation.validateGoals' | translate }}
                </h4>
            </ng-template>

            <ion-card-header>
                <ion-searchbar mode="ios" class="section-search-custom"
                    [placeholder]="'generic.searchByName' | translate"
                    (keyup)="updateSearch($any($event).target.value)"></ion-searchbar>

                <ng-container *ngIf="canValidate">
                    <ion-button mode="ios" color="secondary" (click)="openNewGoalModal()"> {{ 'goalsValidation.newGoal'
                        | translate }} </ion-button>
                </ng-container>
            </ion-card-header>

            <app-user-goals-list
                [goals]="displayedGoals"
                [goalsInputConfig]="inputConfig"
                [processType]="ProcessType.GoalsReviewValidation"
                [canEditGoals]="canValidate && coachingRecordStatus !== TwoPlusTwoCoachingStatus.Authorized"
                [canDeleteGoal]="canValidate && coachingRecordStatus !== TwoPlusTwoCoachingStatus.Authorized"
                (approve)="setGoalApproved($event.goal)"
                (refuse)="setGoalRefused($event.goal)"
                (delete)="confirmDeleteGoal($event.goal)">
            </app-user-goals-list>
        </ion-card>

        <ng-container *ngIf="canValidate && reviewConfig && coachingConfig">
            <div class="bottom-buttons ion-text-right">
                <ion-button mode="ios" color="secondary" class="send" (click)="setGoalsFeedbacks(goals)"> {{
                    'generic.finish' | translate }} </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>